export default __webpack_public_path__ + "static/media/dasmarinas.644e90ca.jpg";